/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_InstitutionInputs */

const en__field_institution = /** @type {(inputs: _Field_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`department`)
};

const de__field_institution = /** @type {(inputs: _Field_InstitutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institution`)
};

/**
* | output |
* | --- |
* | "department" |
*
* @param {_Field_InstitutionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_institution = /** @type {((inputs?: _Field_InstitutionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_InstitutionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_institution(inputs)
	return de__field_institution(inputs)
});